import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-aggiungi-making-teca-backoffice',
  templateUrl: './aggiungi-making-teca-backoffice.component.html',
  styleUrl: './aggiungi-making-teca-backoffice.component.css'
})
export class AggiungiMakingTecaBackofficeComponent {

  constructor(private apiService: ApiService, private router: Router, private datePipe: DatePipe) { }

  formPost!: FormGroup;

  tipi: { tipo: string }[] = [
    { tipo: 'Operatore' },
    { tipo: 'Amministratore' }
  ]

  immagineBox: File | null = null
  immaginiContent: File[] | null = []

  post_data: number[] = [0]

  ngOnInit(): void {

    this.formPost = new FormGroup({
      titolo: new FormControl(null, Validators.required),
      data: new FormControl(null, Validators.required),
      immagine: new FormControl(null, Validators.required)
    })

    this.post_data.map((contenuto, index) => {
      this.formPost.addControl('titolo_' + index, new FormControl(null))
      this.formPost.addControl('descrizione_' + index, new FormControl(null))
      this.formPost.addControl('immagine_' + index, new FormControl(null))
    })

  }

  onImmagineUpload(file: File | File[] | null) {
    if (!file || Array.isArray(file)) {
      this.immagineBox = null;
      this.formPost.patchValue({ immagine: '' });
      return;
    }

    this.formPost.patchValue({ immagine: file.name });

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (isJpgOrPng) {
      this.immagineBox = file;
    }
  };

  onRemoveImmagineUpload() {
    this.immagineBox = null
    this.formPost.patchValue({ immagine: '' });
  }

  onImmagineContenutoUpload(file: File | File[] | null, i: number) {
    if (!file || Array.isArray(file)) {
      this.formPost.patchValue({ ["immagine_" + i]: '' });
      return;
    }
    this.formPost.patchValue({ ["immagine_" + i]: file.name });

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (isJpgOrPng) {
      this.immaginiContent?.push(file);
    }
  };

  onRemoveImmagineContenutoUpload(file: any, i: number) {
    this.immaginiContent?.splice(i, 1)
    this.formPost.patchValue({ ["immagine_" + i]: '' });
  }

  onAddContenuto() {

    this.post_data.push(0)

    this.post_data.map((contenuto, index) => {
      this.formPost.addControl('titolo_' + index, new FormControl(null))
      this.formPost.addControl('descrizione_' + index, new FormControl(null))
      this.formPost.addControl('immagine_' + index, new FormControl(null))
    })

  }

  onRemoveContenuto(index: number) {
    this.post_data.splice(index, 1);

    this.formPost.removeControl('titolo_' + index)
    this.formPost.removeControl('descrizione_' + index)
    this.formPost.removeControl('immagine_' + index)
  }

  onSubmit() {

    const formData = new FormData();
    formData.append('image', this.immagineBox || '');
    formData.append('titolo', this.formPost.get('titolo')?.value);
    formData.append('data', this.datePipe.transform(this.formPost.get('data')?.value, 'yyyy-MM-dd') || '');

    let id_post: number = 0;

    this.apiService.addMakingTecaPost(formData).subscribe({
      next: (data) => {
        this.apiService.setMakingTecaPosts();
        id_post = data.id
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        if (this.post_data.length > 0) {
          this.post_data.map((number, index) => {

            const titolo = this.formPost.get('titolo_' + index)?.value || '';
            const descrizione = this.formPost.get('descrizione_' + index)?.value || '';

            if (titolo.length > 0) {

              const formPostData = new FormData();
              formPostData.append('image', this.immaginiContent![index] || '');
              formPostData.append('titolo', titolo);
              formPostData.append('descrizione', descrizione);
              formPostData.append('id_post', id_post.toString())

              this.apiService.addMakingTecaPostData(formPostData).subscribe({
                next: (data) => this.apiService.setMakingTecaPosts(),
                error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
                complete: () => {

                  if (index == this.post_data.length - 1) {
                    this.router.navigate(['/backoffice/making-teca'])
                  }                  

                }
              })
            }

          })
        } else {
          this.router.navigate(['/backoffice/making-teca'])
        }
      }
    })
  }
}
